export const itemActions: IRowAction[] = [
  {
    id: 'addToProject',
    title: 'Add to Project',
    iconName: 'IconEdit',
    actionType: 'GENERATORS',
  },
];

export const categories = [
  'all',
  'asphalt',
  'concrete',
  'fabric',
  'floor',
  'gem',
  'glass',
  'ground',
  'leather',
  'metal',
  'misc',
  'organic',
  'plastic',
  'rock',
  'roof',
  'sand',
  'sci-fi',
  'stone',
  'vegetation',
  'wall',
  'wood',
];

export const styles = ['all', 'realistic', 'semi-stylized', 'stylized'];
